export const NL_CARE_LOCALSTORAGE_KEY = 'nolimit_care_';
